import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation

const handleClick = () => {
  try {
    const keysToClear = [
      "auth_token",
      "authUser",
      "logintime",
      "user_info",
      "user_id",
    ];
    keysToClear.forEach(key => {
      localStorage.removeItem(key);
    });
    window.location.href = "/login";
  } catch (error) {
    console.log("Error Occured while Suspecious route called");
  }
};

const NotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>404</h1>
      <p style={styles.message}>
        Sorry, the page you are looking for does not exist.
      </p>
      <Link to="/login" style={styles.link} onClick={handleClick}>
        Go Back to Home
      </Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "50px",
    fontFamily: "Arial, sans-serif",
  },
  heading: {
    fontSize: "100px",
    color: "#FF6347",
  },
  message: {
    fontSize: "20px",
    color: "#333",
  },
  link: {
    fontSize: "18px",
    color: "#008CBA",
    textDecoration: "none",
    marginTop: "20px",
    display: "inline-block",
  },
};

export default NotFound;
